import * as React from "react";
import Card from "@mui/material/Card";
import AddIcon from "@mui/icons-material/Add";

const AddCard = ({ onClick }) => {
  return (
    <Card
      sx={{
        width: "345px",
        height: "260px",
        backgroundColor: "#E9E9E9",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: 0,
        boxShadow: 0,
      }}
      onClick={onClick}
    >
      <AddIcon
        sx={{
          color: "#fff",
          width: "64px",
          height: "64px",
        }}
      />
    </Card>
  );
};

export default AddCard;
